import { BaseWebComponentDataProvider } from '../../../../framework/BaseWebComponentDataProvider';
import { CountryData } from '../../../types/country-data';
import { StateData } from '../../../types/state-data';
import { IndustryData } from '../../../types/industry-data';
import { CompanyRoleData } from '../../../types/company-role-data';
import { CompanyTypeData } from '../../../types/company-type-data';
import { CompanyCustomizationData } from '../../../types/company-customization-data';
import { User } from '../../../types/user';
import { TimezoneData } from '../../../types/timezone-data';
import { LanguageData } from '../../../types/language-data';

export abstract class CompanyDetailsFormBaseDataProvider extends BaseWebComponentDataProvider {
  public abstract getCountries(): Promise<CountryData[]>;

  public abstract getStates(): Promise<StateData[]>;

  public abstract getIndustries(): Promise<IndustryData[]>;

  public abstract getCompanyRoles(): Promise<CompanyRoleData[]>;

  public abstract getDefaultLogoId(): Promise<string>;

  public abstract getCompanyTypes(): Promise<CompanyTypeData[]>;

  public abstract getCompanyCustomizations(): Promise<CompanyCustomizationData[]>;

  public abstract getTimezones(): Promise<TimezoneData[]>;

  public abstract getLanguages(): Promise<LanguageData[]>;

  public abstract getLoggedUser(): Promise<User>;

  public abstract getRootVisibilityTree(): Promise<string>;
}
